import { useShallow } from 'zustand/react/shallow';
import useWidth from '../../../../../../components/Hooks/useWidth';
import useProductDetailsStore from '../../../../../../stores/ProductDetails/productDetails.store';
import useTeceoStyles from '../../../../../../useTeceoStyles';
import useOrderBook from '../../../../../order-book/hooks/useOrderBook';
import AllColorsFilter from '../components/AllColorsFilter';
import AvailabilityFilter from '../components/Availability/AvailabilityFilter';
import OrdersFilter from '../components/OrdersFilter';
import ProductLockFilter from '../components/ProductLockFilter';
import RelatedProductsFilter from '../components/RelatedProductsFilter';
import useProductFilters from './hook/useProductFilters';
import { useProductFiltersStyles } from './styles/useProductFilters.styles';
import { ProductFiltersProps } from './types/productFilters.types';

const ProductFilters = ({ productColorId, allColorIds }: ProductFiltersProps) => {
  const { mobileWidth } = useWidth();
  const { isFinishedOrder } = useProductDetailsStore(
    useShallow((state) => ({
      isFinishedOrder: state.productGridParams.isFinishedOrder,
    })),
  );
  const { classes, cx } = useProductFiltersStyles();
  const { classes: teceoClasses } = useTeceoStyles();
  const { filters, showAllColorsFilter, showRelatedProductsFilter, hasNoAvailableGrid, isLoading } =
    useProductFilters({ allColorIds });
  const { allOrders } = useOrderBook();
  const canShowAllOrdersFilter = allOrders.length > 1 && !mobileWidth && !isFinishedOrder;

  return (
    <div className={cx(classes.root, teceoClasses.hideScrollbar)}>
      {showRelatedProductsFilter && <RelatedProductsFilter />}
      {canShowAllOrdersFilter && <OrdersFilter />}
      {showAllColorsFilter && productColorId && (
        <AllColorsFilter productColorId={productColorId} disabled={hasNoAvailableGrid} />
      )}

      {!isLoading && (
        <AvailabilityFilter
          deliveryWindows={filters.deliveryWindows ?? []}
          availabilities={filters.availabilities}
        />
      )}

      <ProductLockFilter />
    </div>
  );
};

export default ProductFilters;
